import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import { resetFocus } from '../common/commonUtilities'
import { TRANSACTION_BUTTON } from '../common/commonUtilities'
import Linkify from 'linkify-react'
import CopyButtonInBox from '../common/components/CopyButtonInBox.jsx'
import { LINKIFY_OPTIONS } from '../common/constants'

export default function FileContents({ fileContents, show, onHide }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      onEntered={resetFocus}
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>{'Transaction details:'}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="copy-button-container">
        <CopyButtonInBox textToCopy={fileContents} />
        <pre style={{ overflow: 'scroll', maxHeight: '80vh' }}>
          <Linkify options={LINKIFY_OPTIONS}>
            {fileContents}
          </Linkify>
        </pre>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} variant="primary" id={TRANSACTION_BUTTON}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
